import { makeAutoObservable } from 'mobx';
import { Loadings, UserInfoType } from '../types';

class AuthState {

  loadings: Loadings = {
    authLoading: false,
  };


  constructor() {
    makeAutoObservable(this); 
  }

  userInfo: UserInfoType | null = null;
}

export const authStateStore = new AuthState();
export type AuthStateStore = typeof authStateStore;
